import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Table } from 'primeng/table';
import { finalize, tap } from 'rxjs';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonAtcViewModel } from 'src/app/model/common/atc.view';
import { CommonAtcService } from './common.atc.service';

@Component({
  selector: '[ms-common-atc-exp-table]',
  templateUrl: './common.atc-exp-table.component.html',
})
export class CommonAtcExpandableTableComponent
  extends BaseComponent
  implements AfterViewInit
{
  @ViewChild('dt') dt?: Table;
  @Output() atcTable: EventEmitter<Table> = new EventEmitter();
  @Input() level: number = 1;
  @Input() parent?: string;
  @Input() isCounter = false;
  @Input() isDoctor = false;

  protected setScreen = false;
  atcList: CommonAtcViewModel[] = [];

  constructor(protected service: CommonAtcService) {
    super();
  }

  ngAfterViewInit() {
    if (!this.parent) {
      this.atcTable.emit(this.dt);
    }
  }

  onInit = () => {
    this.loading = true;
    if (!this.parent) {
      this.subscriptions.push(
        this.service.getLoad().subscribe((atc) => (this.atcList = atc))
      );
    }
    this.read();
  };

  read = () => {
    this.loading = true;
    const service = this.service.readList(this.level, this.parent).pipe(
      finalize(() => (this.loading = false)),
      tap({
        next: (res) => {
          if (this.parent) {
            this.atcList = res;
          }
        },
      })
    );
    this.subscriptions.push(service.subscribe());
  };
}
